import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React, { useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TocStockHeader from "../../../CommonTocComponent/TocHeader/TocStockHeader";
import SingleHeadingText from "../../../CommonTocComponent/TocHeader/SingleHeadingText";
import DiffrentUpiIdData from "./DiffrentUpiIdData";
import { Col, Row } from "react-bootstrap";
const DiffrentUpiId = (props) => {
    const [upi, setUPI] = useState(props.selectedUPI.upi);
    const device = DeviceContext();
    const apply = () => {
        props.setSelectedUPI(props.upiList.find((x) => x.upi === upi));
        props.next();
    };
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Choose different UPI ID", closeFunction: () => {
                    props.back();
                } }) }),
        React.createElement("div", { className: "outer-body-section" },
            React.createElement(DiffrentUpiIdData, { selectedUPI: upi, setUPI: setUPI, upiList: props.upiList })),
        React.createElement("div", { className: "bottom-contents" },
            React.createElement(Row, { className: "bottombtnsection mb-2" },
                React.createElement(Col, { lg: 6, xs: 6 },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: () => props.next() })),
                React.createElement(Col, { lg: 6, xs: 6 },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => apply() })))))) : (React.createElement(GenericDrawer, { show: true, setShow: undefined, headerComp: React.createElement(React.Fragment, null,
            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Choose different UPI ID")), bodyComp: React.createElement(React.Fragment, null,
            React.createElement("div", { className: "outer-body-section overflow-scroll-300" },
                React.createElement(DiffrentUpiIdData, { selectedUPI: upi, setUPI: setUPI, upiList: props.upiList })),
            React.createElement("div", { className: "bottom-contents" },
                React.createElement(Row, { className: "bottombtnsection mb-2  pt-3 bg-white" },
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Add new UPI ID", className: "w-100", onClick: () => props.next() })),
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => apply() }))))) }))));
};
export default DiffrentUpiId;
